import { Box } from "@mui/material";
import React, { useState } from "react";
import { useIntl } from "react-intl";
import IconTooltip from "@metacrm/metacrm-material-ui/dist/IconTooltip";

export default function useGetWalletValueDistributionTable() {
  const { formatMessage } = useIntl();
  const headers = [
    {
      show: true,
      disabledSort: true,
      id: "tokenType",
      label: formatMessage({ id: "global.demographic.tokenType" }),
    },
    {
      show: true,
      disabledSort: true,
      id: "total",
      label: formatMessage({ id: "global.demographic.tokenTotalValue" }),
    },
    {
      show: true,
      disabledSort: true,
      id: "q1",
      label: (
        <Box display="flex" alignItems="center">
          Q1(25%){" "}
          <IconTooltip
            content={formatMessage({
              id: "global.demographic.quartileTooltip",
            })}
          />
        </Box>
      ),
    },
    {
      show: true,
      disabledSort: true,
      id: "q2",
      label: (
        <Box display="flex" alignItems="center">
          Q2(50%){" "}
          <IconTooltip
            content={formatMessage({
              id: "global.demographic.quartileTooltip",
            })}
          />
        </Box>
      ),
    },
    {
      show: true,
      disabledSort: true,
      id: "q3",
      label: (
        <Box display="flex" alignItems="center">
          Q3(75%){" "}
          <IconTooltip
            content={formatMessage({
              id: "global.demographic.quartileTooltip",
            })}
          />
        </Box>
      ),
    },
    {
      show: true,
      disabledSort: true,
      id: "q4",
      label: (
        <Box display="flex" alignItems="center">
          Q4(95%){" "}
          <IconTooltip
            content={formatMessage({
              id: "global.demographic.quartileTooltip",
            })}
          />
        </Box>
      ),
    },
  ];

  return {
    headers,
  };
}
